import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Container, Row, Col, Card, CardBody, FormGroup, Input,
  Label, Button, Modal, ModalHeader, ModalBody, ModalFooter,
  Nav, NavItem, NavLink, CustomInput, Spinner,
} from 'reactstrap'
import { Editor } from 'react-draft-wysiwyg'
import { EditorState, convertToRaw, ContentState } from 'draft-js'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import './modalForms.css'
import ModalDatePicker from './ModalDatePicker'
import LegalDemandOptionsModal from './LegalDemandOptionsModal'
import OfficialLetterSubmitOverlay from './SubmitOverlay'
import moment from 'moment'
import classnames from 'classnames'
import Select from '../../../components/Template/Input/Select'
import DataTable from '../../../components/Template/Table/DataTable'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { getContracts } from '../../../store/ducks/comercial'
import {
  getOfficialLettersCreated,
  postOfficialLetterCreated,
  getOfficialLettersReceived,
  postOfficialLetterReceived,
  updateOfficialLetter,
  generateLegalDemandForOficio,
} from '../../../store/ducks/management'
import oikosApi from '../../../services/oikos'
import { getRegs } from '../../../utils/fc'
import {
  CREATED_STATUS_OPTIONS,
  RECEIVED_STATUS_OPTIONS,
  CREATED_STATUS_COLOR_MAP,
  RECEIVED_STATUS_COLOR_MAP,
  GERENCIA_EMAIL_OPTIONS,
  getNextOficioNumber,
  getRowId,
  buildLegalDemandDefaults,
  MODAL_SELECT_PROPS,
  MODAL_MULTI_SELECT_PROPS,
  EDITOR_TOOLBAR,
  EDITOR_WRAPPER_STYLE,
  EDITOR_INNER_STYLE,
} from './constants'

const rawToHtml = (editorState) => {
  const raw = convertToRaw(editorState.getCurrentContent())
  return raw.blocks.map(block => block.text.trim() ? `<p>${block.text}</p>` : '').join('')
}

const parseDate = (value) => (value ? moment(value).toDate() : null)

const stripHtml = (html) => {
  if (!html) return ''
  const tmp = document.createElement('div')
  tmp.innerHTML = html
  return tmp.textContent || tmp.innerText || ''
}

const htmlToEditorState = (html) => (
  EditorState.createWithContent(ContentState.createFromText(stripHtml(html)))
)

class OfficialLetters extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'created',
      createModalIsOpen: false,
      receiveModalIsOpen: false,
      respondToReceived: null,

      createNumero: '',
      createSignatureResponsible: '',
      createSignatureResponsibleError: '',
      createSubject: '',
      createSubjectError: '',
      createContract: null,
      createDate: '',
      createDateError: '',
      createSendDate: '',
      createReceiveDate: '',
      createRecipient: '',
      createRecipientError: '',
      createBody: EditorState.createEmpty(),
      createBodyError: '',
      createAttachment: null,
      createObservations: '',
      createLinkReceived: null,
      createGerarDemanda: false,
      createDemandaJuridica: null,
      createDemandaModalOpen: false,
      tableDemandaModalOpen: false,
      tableDemandaRow: null,
      tableDemandaDefaults: null,

      receiveNumero: '',
      receiveSender: '',
      receiveSenderError: '',
      receiveContract: null,
      receiveDate: '',
      receiveDateError: '',
      receiveLetterDate: '',
      receiveLetterDateError: '',
      receiveSubjectBody: EditorState.createEmpty(),
      receiveSubjectBodyError: '',
      receiveForwardDepartments: [],
      receiveForwardDepartmentsError: '',
      receiveCcEmail: '',
      receiveAttachment: null,
      receiveObservations: '',
      receiveTemPrazo: false,
      receivePrazo: '',
      receiveGerarDemanda: false,
      receiveDemandaJuridica: null,
      receiveDemandaModalOpen: false,
      receiveDemandaDefaults: null,

      tableReceivedDemandaModalOpen: false,
      tableReceivedDemandaRow: null,
      tableReceivedDemandaDefaults: null,

      editCreatedModalIsOpen: false,
      editingCreatedRow: null,
      editCreatedNumero: '',
      editCreatedStatus: 'Em elaboração',
      editCreatedSignatureResponsible: '',
      editCreatedSubject: '',
      editCreatedContract: null,
      editCreatedDate: '',
      editCreatedSendDate: '',
      editCreatedReceiveDate: '',
      editCreatedRecipient: '',
      editCreatedBody: EditorState.createEmpty(),
      editCreatedObservations: '',
      editCreatedLinkReceived: null,

      editReceivedModalIsOpen: false,
      editingReceivedRow: null,
      editReceivedNumero: '',
      editReceivedSender: '',
      editReceivedContract: null,
      editReceivedDate: '',
      editReceivedLetterDate: '',
      editReceivedSubjectBody: EditorState.createEmpty(),
      editReceivedForwardDepartments: [],
      editReceivedCcEmail: '',
      editReceivedObservations: '',
      editReceivedTemPrazo: false,
      editReceivedPrazo: '',

      pfOptions: [],
    }
  }

  componentDidMount() {
    this.props.getContracts()
    this.props.getOfficialLettersCreated()
    this.props.getOfficialLettersReceived()
    this.fetchPfs()
  }

  componentDidUpdate(prevProps) {
    const { management } = this.props
    const prevMgmt = prevProps.management

    if (
      prevMgmt.postOfficialLetterCreatedIsLoading
      && !management.postOfficialLetterCreatedIsLoading
      && !management.postOfficialLetterCreatedError
      && this.state.createModalIsOpen
    ) {
      this.setState(this.resetCreateForm())
    }

    if (
      prevMgmt.postOfficialLetterReceivedIsLoading
      && !management.postOfficialLetterReceivedIsLoading
      && !management.postOfficialLetterReceivedError
      && this.state.receiveModalIsOpen
    ) {
      this.setState({ ...this.resetReceiveForm(), receiveAttachment: null })
    }
  }

  fetchPfs = async () => {
    try {
      const data = await getRegs('pf', { pf_ativo: 1 })
      this.setState({
        pfOptions: data.map(p => ({
          value: p.pf_nomeExibicao || p.pf_nome,
          label: p.pf_nomeExibicao || p.pf_nome,
        })),
      })
    } catch (e) {
      console.log('Erro ao buscar PF', e)
    }
  }

  get currentPfId() {
    return Number(this.props.auth?.user?.pf_id) || 0
  }

  get createdLetters() {
    const list = Array.isArray(this.props.management.officialLettersCreated)
      ? [...this.props.management.officialLettersCreated]
      : []
    return list.sort((a, b) => Number(getRowId(b, true)) - Number(getRowId(a, true)))
  }

  get receivedLetters() {
    const list = Array.isArray(this.props.management.officialLettersReceived)
      ? [...this.props.management.officialLettersReceived]
      : []
    return list.sort((a, b) => Number(getRowId(b, false)) - Number(getRowId(a, false)))
  }

  getContractName = (id) => {
    const contracts = this.props.comercial.getContractsData || []
    const c = contracts.find(item => Number(item.contrato_id) === Number(id))
    return c ? `${c.pj_nomefanta || 'Sem Nome'} — Nº ${c.contrato_num || id}` : id
  }

  getReceivedLabel = (id) => {
    const row = this.receivedLetters.find(r => Number(getRowId(r, false)) === Number(id))
    if (!row) return `ID ${id}`
    const num = row.numero_oficio ? `${row.numero_oficio} — ` : ''
    return `${num}${row.remetente || 'Sem remetente'}`
  }

  getCreatedLabel = (id) => {
    const row = this.createdLetters.find(r => Number(getRowId(r, true)) === Number(id))
    if (!row) return `ID ${id}`
    const num = row.numero_oficio ? `${row.numero_oficio} — ` : ''
    return `${num}${row.assunto || 'Sem assunto'}`
  }

  handleDownloadPdf = async (anexoPath) => {
    if (!anexoPath) return
    try {
      const baseUrl = process.env.REACT_APP_URL || 'https://oikoslab.ecoss.is/'
      const fullUrl = `${baseUrl}oikos/${anexoPath}`
      const res = await oikosApi.get(fullUrl, { responseType: 'blob' })
      const blob = new Blob([res.data])
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', anexoPath.split('/').pop() || 'anexo.pdf')
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    } catch (e) {
      console.error('Erro ao baixar anexo:', e)
      alert('Falha ao baixar o anexo.')
    }
  }

  resetCreateForm = (extra = {}) => ({
    createModalIsOpen: false,
    respondToReceived: null,
    createNumero: '',
    createSignatureResponsible: '',
    createSignatureResponsibleError: '',
    createSubject: '',
    createSubjectError: '',
    createContract: null,
    createDate: '',
    createDateError: '',
    createSendDate: '',
    createReceiveDate: '',
    createRecipient: '',
    createRecipientError: '',
    createBody: EditorState.createEmpty(),
    createBodyError: '',
    createAttachment: null,
    createObservations: '',
    createLinkReceived: null,
    createGerarDemanda: false,
    createDemandaJuridica: null,
    createDemandaModalOpen: false,
    createDemandaDefaults: null,
    ...extra,
  })

  openCreateDemandaModal = () => {
    const teorOficio = rawToHtml(this.state.createBody).trim()
    const defaults = buildLegalDemandDefaults({
      solicitante: this.state.createSignatureResponsible,
      assunto: this.state.createSubject,
      numeroOficio: this.state.createNumero,
      dataOficio: this.state.createDate || null,
      teor: teorOficio !== '<p></p>' ? teorOficio : '',
    })
    if (this.state.createDemandaJuridica) {
      Object.assign(defaults, this.state.createDemandaJuridica)
      defaults.prazo_atendimento = this.state.createDemandaJuridica.prazo_atendimento
        ? moment(this.state.createDemandaJuridica.prazo_atendimento).toDate()
        : defaults.prazo_atendimento
    }
    this.setState({ createDemandaModalOpen: true, createDemandaDefaults: defaults })
  }

  closeCreateDemandaModal = (revertCheckbox = true) => {
    this.setState(prev => ({
      createDemandaModalOpen: false,
      createGerarDemanda: revertCheckbox && !prev.createDemandaJuridica ? false : prev.createGerarDemanda,
    }))
  }

  handleCreateDemandaConfirm = (demandaJuridica) => {
    this.setState({
      createDemandaJuridica: demandaJuridica,
      createGerarDemanda: true,
      createDemandaModalOpen: false,
    })
  }

  handleCreateGerarDemandaChange = (e) => {
    const checked = e.target.checked
    if (checked && this.getCreateFormBlockedDemandId()) return
    if (checked) {
      this.setState({ createGerarDemanda: true }, this.openCreateDemandaModal)
    } else {
      this.setState({ createGerarDemanda: false, createDemandaJuridica: null })
    }
  }

  getCreateFormBlockedDemandId = () => {
    if (this.state.respondToReceived?.solicitacoes_juridicas_id) {
      return this.state.respondToReceived.solicitacoes_juridicas_id
    }
    const linkedId = this.state.createLinkReceived?.value
      || (this.state.respondToReceived ? getRowId(this.state.respondToReceived, false) : null)
    if (!linkedId) return null
    const received = this.receivedLetters.find(r => Number(getRowId(r, false)) === Number(linkedId))
    return received?.solicitacoes_juridicas_id || null
  }

  openTableDemandaModal = (row) => {
    const defaults = buildLegalDemandDefaults({
      solicitante: row.responsavel_assinatura,
      assunto: row.assunto,
      numeroOficio: row.numero_oficio,
      dataOficio: row.data_oficio ? moment(row.data_oficio).toDate() : null,
      teor: row.teor || '',
    })
    this.setState({
      tableDemandaModalOpen: true,
      tableDemandaRow: row,
      tableDemandaDefaults: defaults,
    })
  }

  closeTableDemandaModal = () => {
    this.setState({ tableDemandaModalOpen: false, tableDemandaRow: null })
  }

  handleTableDemandaConfirm = (demandaJuridica) => {
    const { tableDemandaRow } = this.state
    if (!tableDemandaRow) return
    this.props.generateLegalDemandForOficio({
      row: tableDemandaRow,
      demanda_juridica: demandaJuridica,
      contrato_id: tableDemandaRow.contrato_id,
      source: 'created',
    })
    this.setState({ tableDemandaModalOpen: false, tableDemandaRow: null })
  }

  getLinkedReceivedDemandId = (createdRow) => {
    const receivedId = createdRow?.oficio_origem_recebido_id || createdRow?.oficios_recebidos_id
    if (!receivedId) return null
    const received = this.receivedLetters.find(r => Number(getRowId(r, false)) === Number(receivedId))
    return received?.solicitacoes_juridicas_id || null
  }

  getEffectiveCreatedDemandId = (createdRow) => (
    createdRow?.solicitacoes_juridicas_id || this.getLinkedReceivedDemandId(createdRow) || null
  )

  getEffectiveReceivedDemandId = (receivedRow) => {
    if (receivedRow?.solicitacoes_juridicas_id) return receivedRow.solicitacoes_juridicas_id
    if (!receivedRow?.oficios_criados_resposta_id) return null
    const created = this.createdLetters.find(
      c => Number(getRowId(c, true)) === Number(receivedRow.oficios_criados_resposta_id)
    )
    return created?.solicitacoes_juridicas_id || null
  }

  openReceiveDemandaModal = () => {
    const teorOficio = rawToHtml(this.state.receiveSubjectBody).trim()
    const defaults = buildLegalDemandDefaults({
      solicitante: this.props.auth?.user?.pf_nomeExibicao || this.props.auth?.user?.pf_nome || '',
      assunto: '',
      numeroOficio: this.state.receiveNumero,
      dataOficio: this.state.receivePrazo || this.state.receiveLetterDate || null,
      teor: teorOficio !== '<p></p>' ? teorOficio : '',
    })
    if (this.state.receiveNumero) {
      defaults.fato_gerador = `Ofício recebido ${this.state.receiveNumero}`
    }
    if (this.state.receiveDemandaJuridica) {
      Object.assign(defaults, this.state.receiveDemandaJuridica)
      defaults.prazo_atendimento = this.state.receiveDemandaJuridica.prazo_atendimento
        ? moment(this.state.receiveDemandaJuridica.prazo_atendimento).toDate()
        : defaults.prazo_atendimento
    }
    this.setState({ receiveDemandaModalOpen: true, receiveDemandaDefaults: defaults })
  }

  closeReceiveDemandaModal = (revertCheckbox = true) => {
    this.setState(prev => ({
      receiveDemandaModalOpen: false,
      receiveGerarDemanda: revertCheckbox && !prev.receiveDemandaJuridica ? false : prev.receiveGerarDemanda,
    }))
  }

  handleReceiveDemandaConfirm = (demandaJuridica) => {
    this.setState({
      receiveDemandaJuridica: demandaJuridica,
      receiveGerarDemanda: true,
      receiveDemandaModalOpen: false,
    })
  }

  handleReceiveGerarDemandaChange = (e) => {
    const checked = e.target.checked
    if (checked) {
      this.setState({ receiveGerarDemanda: true }, this.openReceiveDemandaModal)
    } else {
      this.setState({ receiveGerarDemanda: false, receiveDemandaJuridica: null })
    }
  }

  openTableReceivedDemandaModal = (row) => {
    const defaults = buildLegalDemandDefaults({
      solicitante: this.props.auth?.user?.pf_nomeExibicao || this.props.auth?.user?.pf_nome || '',
      assunto: '',
      numeroOficio: row.numero_oficio,
      dataOficio: row.prazo_resposta
        ? moment(row.prazo_resposta).toDate()
        : (row.data_oficio ? moment(row.data_oficio).toDate() : null),
      teor: row.assunto_teor || '',
    })
    if (row.numero_oficio) {
      defaults.fato_gerador = `Ofício recebido ${row.numero_oficio}`
    }
    this.setState({
      tableReceivedDemandaModalOpen: true,
      tableReceivedDemandaRow: row,
      tableReceivedDemandaDefaults: defaults,
    })
  }

  closeTableReceivedDemandaModal = () => {
    this.setState({ tableReceivedDemandaModalOpen: false, tableReceivedDemandaRow: null })
  }

  handleTableReceivedDemandaConfirm = (demandaJuridica) => {
    const { tableReceivedDemandaRow } = this.state
    if (!tableReceivedDemandaRow) return
    this.props.generateLegalDemandForOficio({
      row: tableReceivedDemandaRow,
      demanda_juridica: demandaJuridica,
      contrato_id: tableReceivedDemandaRow.contrato_id,
      source: 'received',
    })
    this.setState({ tableReceivedDemandaModalOpen: false, tableReceivedDemandaRow: null })
  }

  toggleCreateModal = () => {
    if (this.props.management.postOfficialLetterCreatedIsLoading) return
    this.setState(prev => {
      if (prev.createModalIsOpen) return this.resetCreateForm()
      const numero = getNextOficioNumber(this.createdLetters)
      return { createModalIsOpen: true, createNumero: numero, respondToReceived: null }
    })
  }

  openRespondModal = (receivedRow) => {
    const numero = getNextOficioNumber(this.createdLetters)
    const subjectPrefix = receivedRow.numero_oficio
      ? `Resposta ao ofício ${receivedRow.numero_oficio}`
      : `Resposta ao ofício recebido #${getRowId(receivedRow, false)}`
    this.setState({
      createModalIsOpen: true,
      respondToReceived: receivedRow,
      createNumero: numero,
      createSubject: subjectPrefix,
      createContract: receivedRow.contrato_id
        ? { value: receivedRow.contrato_id, label: this.getContractName(receivedRow.contrato_id) }
        : null,
      createRecipient: receivedRow.remetente || '',
      createObservations: `Em resposta ao ofício recebido de ${receivedRow.remetente || '—'}.`,
    })
  }

  resetReceiveForm = () => ({
    receiveModalIsOpen: false,
    receiveNumero: '',
    receiveSender: '',
    receiveSenderError: '',
    receiveContract: null,
    receiveDate: '',
    receiveDateError: '',
    receiveLetterDate: '',
    receiveLetterDateError: '',
    receiveSubjectBody: EditorState.createEmpty(),
    receiveSubjectBodyError: '',
    receiveForwardDepartments: [],
    receiveForwardDepartmentsError: '',
    receiveCcEmail: '',
    receiveAttachment: null,
    receiveObservations: '',
    receiveTemPrazo: false,
    receivePrazo: '',
    receiveGerarDemanda: false,
    receiveDemandaJuridica: null,
    receiveDemandaModalOpen: false,
    receiveDemandaDefaults: null,
  })

  toggleReceiveModal = () => {
    if (this.props.management.postOfficialLetterReceivedIsLoading) return
    this.setState(prev => {
      if (prev.receiveModalIsOpen) return this.resetReceiveForm()
      return {
        receiveModalIsOpen: true,
        receiveNumero: '',
      }
    })
  }

  parseForwardDepartments = (emailsStr, labelsStr) => {
    if (!emailsStr) return []
    const emails = String(emailsStr).split(',').map(s => s.trim()).filter(Boolean)
    const labels = labelsStr ? String(labelsStr).split(',').map(s => s.trim()) : []
    return emails.map((email, i) => {
      const fromOptions = GERENCIA_EMAIL_OPTIONS.find(o => o.value === email)
      return fromOptions || { value: email, label: labels[i] || email }
    })
  }

  openEditCreatedModal = (row) => {
    this.setState({
      editCreatedModalIsOpen: true,
      editingCreatedRow: row,
      editCreatedNumero: row.numero_oficio || '',
      editCreatedStatus: row.status || 'Em elaboração',
      editCreatedSignatureResponsible: row.responsavel_assinatura || '',
      editCreatedSubject: row.assunto || '',
      editCreatedContract: row.contrato_id
        ? { value: row.contrato_id, label: this.getContractName(row.contrato_id) }
        : null,
      editCreatedDate: parseDate(row.data_oficio),
      editCreatedSendDate: parseDate(row.data_envio),
      editCreatedReceiveDate: parseDate(row.data_recebimento),
      editCreatedRecipient: row.destinatario || '',
      editCreatedBody: htmlToEditorState(row.teor),
      editCreatedObservations: row.observacoes || '',
      editCreatedLinkReceived: row.oficios_recebidos_id
        ? { value: row.oficios_recebidos_id, label: this.getReceivedLabel(row.oficios_recebidos_id) }
        : null,
    })
  }

  closeEditCreatedModal = () => {
    this.setState({
      editCreatedModalIsOpen: false,
      editingCreatedRow: null,
    })
  }

  openEditReceivedModal = (row) => {
    this.setState({
      editReceivedModalIsOpen: true,
      editingReceivedRow: row,
      editReceivedNumero: row.numero_oficio || '',
      editReceivedSender: row.remetente || '',
      editReceivedContract: row.contrato_id
        ? { value: row.contrato_id, label: this.getContractName(row.contrato_id) }
        : null,
      editReceivedDate: parseDate(row.data_recebimento),
      editReceivedLetterDate: parseDate(row.data_oficio),
      editReceivedSubjectBody: htmlToEditorState(row.assunto_teor),
      editReceivedCcEmail: row.com_copia_para || '',
      editReceivedObservations: row.observacoes || '',
      editReceivedTemPrazo: !!row.tem_prazo_resposta,
      editReceivedPrazo: parseDate(row.prazo_resposta),
    })
  }

  closeEditReceivedModal = () => {
    this.setState({
      editReceivedModalIsOpen: false,
      editingReceivedRow: null,
    })
  }

  handleEditCreatedSubmit = () => {
    const { editingCreatedRow } = this.state
    if (!editingCreatedRow) return

    const bodyHtml = rawToHtml(this.state.editCreatedBody).trim()
    if (!this.state.editCreatedNumero.trim() || !bodyHtml || bodyHtml === '<p></p>') return

    this.props.updateOfficialLetter({
      table: 'oficios_criados',
      idField: 'oficios_criados_id',
      idValue: getRowId(editingCreatedRow, true),
      contrato_id: editingCreatedRow.contrato_id,
      data: {
        numero_oficio: this.state.editCreatedNumero.trim(),
        status: this.state.editCreatedStatus,
        responsavel_assinatura: this.state.editCreatedSignatureResponsible,
        assunto: this.state.editCreatedSubject,
        destinatario: this.state.editCreatedRecipient,
        data_oficio: this.state.editCreatedDate ? moment(this.state.editCreatedDate).format('YYYY-MM-DD') : null,
        data_envio: this.state.editCreatedSendDate ? moment(this.state.editCreatedSendDate).format('YYYY-MM-DD') : null,
        data_recebimento: this.state.editCreatedReceiveDate ? moment(this.state.editCreatedReceiveDate).format('YYYY-MM-DD') : null,
        teor: bodyHtml,
        observacoes: this.state.editCreatedObservations,
        oficios_recebidos_id: this.state.editCreatedLinkReceived?.value || null,
      },
      silent: false,
    })
    this.closeEditCreatedModal()
  }

  handleEditReceivedSubmit = () => {
    const { editingReceivedRow } = this.state
    if (!editingReceivedRow) return

    const bodyHtml = rawToHtml(this.state.editReceivedSubjectBody).trim()
    if (!this.state.editReceivedNumero.trim() || !bodyHtml || bodyHtml === '<p></p>') return
    if (this.state.editReceivedTemPrazo && !this.state.editReceivedPrazo) return

    this.props.updateOfficialLetter({
      table: 'oficios_recebidos',
      idField: 'oficios_recebidos_id',
      idValue: getRowId(editingReceivedRow, false),
      contrato_id: editingReceivedRow.contrato_id,
      data: {
        numero_oficio: this.state.editReceivedNumero.trim(),
        remetente: this.state.editReceivedSender,
        data_recebimento: this.state.editReceivedDate ? moment(this.state.editReceivedDate).format('YYYY-MM-DD') : null,
        data_oficio: this.state.editReceivedLetterDate ? moment(this.state.editReceivedLetterDate).format('YYYY-MM-DD') : null,
        assunto_teor: bodyHtml,
        observacoes: this.state.editReceivedObservations,
        tem_prazo_resposta: this.state.editReceivedTemPrazo ? 1 : 0,
        prazo_resposta: this.state.editReceivedTemPrazo && this.state.editReceivedPrazo
          ? moment(this.state.editReceivedPrazo).format('YYYY-MM-DD')
          : null,
      },
      silent: false,
    })
    this.closeEditReceivedModal()
  }

  renderStatusBadge = (status, isCreated) => {
    const colorMap = isCreated ? CREATED_STATUS_COLOR_MAP : RECEIVED_STATUS_COLOR_MAP
    const color = colorMap[status] || '#aaa'
    return (
      <span style={{
        display: 'inline-block',
        border: `2px solid ${color}`,
        borderRadius: 4,
        padding: '2px 8px',
        fontSize: 11,
        color,
        fontWeight: 'bold',
        background: '#fff',
        whiteSpace: 'nowrap',
      }}>
        {status || '—'}
      </span>
    )
  }

  handleCreateSubmit = () => {
    const {
      createNumero,
      createSignatureResponsible,
      createSubject,
      createContract,
      createDate,
      createRecipient,
      createBody,
      createAttachment,
      createSendDate,
      createReceiveDate,
      createLinkReceived,
      createGerarDemanda,
      respondToReceived,
    } = this.state

    let isValid = true
    if (!createNumero.trim()) {
      isValid = false
    }
    if (!createSignatureResponsible.trim()) {
      this.setState({ createSignatureResponsibleError: 'Campo obrigatório.' })
      isValid = false
    }
    if (!createSubject.trim()) {
      this.setState({ createSubjectError: 'Campo obrigatório.' })
      isValid = false
    }
    if (!createDate) {
      this.setState({ createDateError: 'Campo obrigatório.' })
      isValid = false
    }
    if (!createRecipient.trim()) {
      this.setState({ createRecipientError: 'Campo obrigatório.' })
      isValid = false
    }
    const createBodyHtml = rawToHtml(createBody).trim()
    if (!createBodyHtml || createBodyHtml === '<p></p>') {
      this.setState({ createBodyError: 'Campo obrigatório.' })
      isValid = false
    }

    if (!isValid) return

    if (createGerarDemanda && !this.state.createDemandaJuridica) {
      this.openCreateDemandaModal()
      return
    }
    if (createGerarDemanda && this.getCreateFormBlockedDemandId()) {
      return
    }

    const newLetter = {
      numero_oficio: createNumero.trim(),
      data_oficio: moment(createDate).format('YYYY-MM-DD'),
      data_envio: createSendDate ? moment(createSendDate).format('YYYY-MM-DD') : null,
      data_recebimento: createReceiveDate ? moment(createReceiveDate).format('YYYY-MM-DD') : null,
      responsavel_assinatura: createSignatureResponsible,
      assunto: createSubject,
      destinatario: createRecipient,
      teor: createBodyHtml,
      anexo: createAttachment ? createAttachment.name : '',
      anexoFile: createAttachment,
      observacoes: this.state.createObservations,
      status: 'Em elaboração',
      gerar_demanda_juridica: createGerarDemanda,
      demanda_juridica: createGerarDemanda ? this.state.createDemandaJuridica : null,
      criado_por_pf_id: this.currentPfId || null,
    }

    if (createContract) newLetter.contrato_id = createContract.value
    if (createLinkReceived) newLetter.oficios_recebidos_id = createLinkReceived.value
    if (respondToReceived) {
      const receivedId = getRowId(respondToReceived, false)
      newLetter.oficio_origem_recebido_id = receivedId
      newLetter.oficios_recebidos_id = receivedId
    }

    this.props.postOfficialLetterCreated(newLetter)
  }

  handleReceiveSubmit = () => {
    const {
      receiveNumero,
      receiveSender,
      receiveContract,
      receiveDate,
      receiveLetterDate,
      receiveSubjectBody,
      receiveForwardDepartments,
      receiveCcEmail,
      receiveAttachment,
      receiveTemPrazo,
      receivePrazo,
      receiveGerarDemanda,
      receiveDemandaJuridica,
    } = this.state

    let isValid = true
    if (!receiveNumero.trim()) isValid = false
    if (!receiveSender.trim()) {
      this.setState({ receiveSenderError: 'Campo obrigatório.' })
      isValid = false
    }
    if (!receiveDate) {
      this.setState({ receiveDateError: 'Campo obrigatório.' })
      isValid = false
    }
    if (!receiveLetterDate) {
      this.setState({ receiveLetterDateError: 'Campo obrigatório.' })
      isValid = false
    }
    const receiveSubjectBodyHtml = rawToHtml(receiveSubjectBody).trim()
    if (!receiveSubjectBodyHtml || receiveSubjectBodyHtml === '<p></p>') {
      this.setState({ receiveSubjectBodyError: 'Campo obrigatório.' })
      isValid = false
    }
    if (!receiveForwardDepartments || receiveForwardDepartments.length === 0) {
      this.setState({ receiveForwardDepartmentsError: 'Campo obrigatório.' })
      isValid = false
    }
    if (receiveTemPrazo && !receivePrazo) isValid = false

    if (!isValid) return

    if (receiveGerarDemanda && !receiveDemandaJuridica) {
      this.openReceiveDemandaModal()
      return
    }

    const selectedDeptNames = receiveForwardDepartments.map(d => d.label).join(', ')
    const selectedEmails = receiveForwardDepartments.map(d => d.value).join(', ')

    const newLetter = {
      numero_oficio: receiveNumero.trim(),
      data_recebimento: moment(receiveDate).format('YYYY-MM-DD'),
      data_oficio: moment(receiveLetterDate).format('YYYY-MM-DD'),
      remetente: receiveSender,
      assunto_teor: receiveSubjectBodyHtml,
      encaminhar_para_email: selectedEmails,
      setor_responsavel: selectedDeptNames,
      com_copia_para: receiveCcEmail,
      anexo: receiveAttachment ? receiveAttachment.name : '',
      anexoFile: receiveAttachment,
      observacoes: this.state.receiveObservations,
      status: 'Resposta pendente',
      tem_prazo_resposta: receiveTemPrazo ? 1 : 0,
      prazo_resposta: receiveTemPrazo && receivePrazo ? moment(receivePrazo).format('YYYY-MM-DD') : null,
      criado_por_pf_id: this.currentPfId || null,
      gerar_demanda_juridica: receiveGerarDemanda,
      demanda_juridica: receiveGerarDemanda ? receiveDemandaJuridica : null,
    }

    if (receiveContract) newLetter.contrato_id = receiveContract.value
    this.props.postOfficialLetterReceived(newLetter)
  }

  renderCreatedTable = () => (
    <DataTable
      data={{
        columns: [
          { label: 'Nº Ofício', field: 'numero', sort: 'disabled' },
          { label: 'Data do Ofício', field: 'letterDate', sort: 'disabled' },
          { label: 'Data Envio', field: 'sendDate', sort: 'disabled' },
          { label: 'Data Recebimento', field: 'receiveDateCol', sort: 'disabled' },
          { label: 'Responsável', field: 'signer', sort: 'disabled' },
          { label: 'Assunto', field: 'subject', sort: 'disabled' },
          { label: 'Contrato', field: 'contract', sort: 'disabled' },
          { label: 'Destinatário', field: 'recipient', sort: 'disabled' },
          { label: 'Vínculo recebido', field: 'linkReceived', sort: 'disabled' },
          { label: 'Demanda jurídica', field: 'legalDemand', sort: 'disabled' },
          { label: 'Status', field: 'status', sort: 'disabled' },
          { label: 'Anexo', field: 'attachment', sort: 'disabled' },
          { label: 'Ações', field: 'actions', sort: 'disabled' },
        ],
        rows: this.createdLetters.map(row => ({
          numero: row.numero_oficio || '—',
          letterDate: row.data_oficio ? moment(row.data_oficio).format('DD/MM/YYYY') : '—',
          sendDate: row.data_envio ? moment(row.data_envio).format('DD/MM/YYYY') : '—',
          receiveDateCol: row.data_recebimento ? moment(row.data_recebimento).format('DD/MM/YYYY') : '—',
          signer: row.responsavel_assinatura,
          subject: row.assunto,
          contract: row.contrato_id ? this.getContractName(row.contrato_id) : '—',
          recipient: row.destinatario,
          linkReceived: row.oficios_recebidos_id
            ? this.getReceivedLabel(row.oficios_recebidos_id)
            : '—',
          legalDemand: (() => {
            const demandId = this.getEffectiveCreatedDemandId(row)
            return demandId ? `#${demandId}` : '—'
          })(),
          status: this.renderStatusBadge(row.status, true),
          attachment: row.anexo ? (
            <span style={{ cursor: 'pointer' }} onClick={() => this.handleDownloadPdf(row.anexo)} title="Ver anexo">
              <i className="ri-attachment-line" style={{ fontSize: '18px', color: '#556ee6' }} />
            </span>
          ) : '—',
          actions: (() => {
            const demandId = this.getEffectiveCreatedDemandId(row)
            return (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 120 }}>
                <Button color="primary" size="sm" onClick={() => this.openEditCreatedModal(row)}>
                  Editar
                </Button>
                <Button
                  color="success"
                  size="sm"
                  onClick={() => this.openTableDemandaModal(row)}
                  disabled={!!demandId}
                  title={demandId ? `Demanda #${demandId} já vinculada` : ''}
                >
                  Gerar demanda jurídica
                </Button>
              </div>
            )
          })(),
        })),
      }}
    />
  )

  renderReceivedTable = () => (
    <DataTable
      data={{
        columns: [
          { label: 'Nº Ofício', field: 'numero', sort: 'disabled' },
          { label: 'Data Recebimento', field: 'receiptDate', sort: 'disabled' },
          { label: 'Data do Ofício', field: 'letterDate', sort: 'disabled' },
          { label: 'Remetente', field: 'sender', sort: 'disabled' },
          { label: 'Contrato', field: 'contract', sort: 'disabled' },
          { label: 'Assunto/Teor', field: 'subjectBody', sort: 'disabled' },
          { label: 'Encaminhar para', field: 'forwardTo', sort: 'disabled' },
          { label: 'Prazo resposta', field: 'deadline', sort: 'disabled' },
          { label: 'Demanda jurídica', field: 'legalDemand', sort: 'disabled' },
          { label: 'Status', field: 'status', sort: 'disabled' },
          { label: 'Resposta', field: 'response', sort: 'disabled' },
          { label: 'Anexo', field: 'attachment', sort: 'disabled' },
          { label: 'Ações', field: 'actions', sort: 'disabled' },
        ],
        rows: this.receivedLetters.map(row => {
          const demandId = this.getEffectiveReceivedDemandId(row)
          return {
            numero: row.numero_oficio || '—',
            receiptDate: row.data_recebimento ? moment(row.data_recebimento).format('DD/MM/YYYY') : '—',
            letterDate: row.data_oficio ? moment(row.data_oficio).format('DD/MM/YYYY') : '—',
            sender: row.remetente,
            contract: row.contrato_id ? this.getContractName(row.contrato_id) : '—',
            subjectBody: <div dangerouslySetInnerHTML={{ __html: row.assunto_teor }} />,
            forwardTo: row.encaminhar_para_email,
            deadline: row.tem_prazo_resposta
              ? (row.prazo_resposta ? moment(row.prazo_resposta).format('DD/MM/YYYY') : '—')
              : '—',
            legalDemand: demandId ? `#${demandId}` : '—',
            status: this.renderStatusBadge(row.status, false),
            response: row.oficios_criados_resposta_id
              ? this.getCreatedLabel(row.oficios_criados_resposta_id)
              : '—',
            attachment: row.anexo ? (
              <span style={{ cursor: 'pointer' }} onClick={() => this.handleDownloadPdf(row.anexo)} title="Ver anexo">
                <i className="ri-attachment-line" style={{ fontSize: '18px', color: '#556ee6' }} />
              </span>
            ) : '—',
            actions: (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 120 }}>
                <Button color="secondary" size="sm" onClick={() => this.openEditReceivedModal(row)}>
                  Editar
                </Button>
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => this.openRespondModal(row)}
                  disabled={!!row.oficios_criados_resposta_id}
                >
                  Responder
                </Button>
                <Button
                  color="success"
                  size="sm"
                  onClick={() => this.openTableReceivedDemandaModal(row)}
                  disabled={!!demandId}
                  title={demandId ? `Demanda #${demandId} já vinculada` : ''}
                >
                  Gerar demanda jurídica
                </Button>
              </div>
            ),
          }
        }),
      }}
    />
  )

  renderEditCreatedModal = () => {
    const {
      editCreatedModalIsOpen,
      editingCreatedRow,
      editCreatedNumero,
      editCreatedStatus,
      editCreatedSignatureResponsible,
      editCreatedSubject,
      editCreatedDate,
      editCreatedSendDate,
      editCreatedReceiveDate,
      editCreatedRecipient,
      editCreatedBody,
      editCreatedObservations,
      editCreatedLinkReceived,
    } = this.state

    const receivedOptions = this.receivedLetters.map(r => ({
      value: getRowId(r, false),
      label: this.getReceivedLabel(getRowId(r, false)),
    }))

    return (
      <Modal size="lg" scrollable centered enforceFocus={false} isOpen={editCreatedModalIsOpen} toggle={this.closeEditCreatedModal}>
        <ModalHeader toggle={this.closeEditCreatedModal}>Editar Ofício Criado</ModalHeader>
        <ModalBody className="official-letters-modal">
          <FormGroup>
            <Label>Número do ofício</Label>
            <Input type="text" value={editCreatedNumero} onChange={e => this.setState({ editCreatedNumero: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Status</Label>
            <Input type="select" value={editCreatedStatus} onChange={e => this.setState({ editCreatedStatus: e.target.value })}>
              {CREATED_STATUS_OPTIONS.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Responsável da assinatura</Label>
            <Input type="text" value={editCreatedSignatureResponsible}
              onChange={e => this.setState({ editCreatedSignatureResponsible: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Assunto</Label>
            <Input type="text" value={editCreatedSubject} onChange={e => this.setState({ editCreatedSubject: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Contrato vinculado</Label>
            <Input
              type="text"
              disabled
              value={editingCreatedRow?.contrato_id ? this.getContractName(editingCreatedRow.contrato_id) : '—'}
            />
          </FormGroup>
          <Row>
            <Col lg={4} md={12} className="mb-2">
              <FormGroup className="mb-0">
                <Label>Data do ofício</Label>
                <ModalDatePicker locale="pt-BR" className="form-control" selected={editCreatedDate} dateFormat="dd/MM/yyyy"
                  onChange={date => this.setState({ editCreatedDate: date })} />
              </FormGroup>
            </Col>
            <Col lg={4} md={12} className="mb-2">
              <FormGroup className="mb-0">
                <Label>Data de envio</Label>
                <ModalDatePicker locale="pt-BR" className="form-control" selected={editCreatedSendDate} dateFormat="dd/MM/yyyy" isClearable
                  onChange={date => this.setState({ editCreatedSendDate: date })} />
              </FormGroup>
            </Col>
            <Col lg={4} md={12} className="mb-2">
              <FormGroup className="mb-0">
                <Label>Data de recebimento</Label>
                <ModalDatePicker locale="pt-BR" className="form-control" selected={editCreatedReceiveDate} dateFormat="dd/MM/yyyy" isClearable
                  onChange={date => this.setState({ editCreatedReceiveDate: date })} />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label>Destinatário</Label>
            <Input type="text" value={editCreatedRecipient} onChange={e => this.setState({ editCreatedRecipient: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Vincular a ofício recebido</Label>
            <Select
              {...MODAL_SELECT_PROPS}
              isClearable placeholder="Selecione..." value={editCreatedLinkReceived} options={receivedOptions}
              onChange={opt => this.setState({ editCreatedLinkReceived: opt })} />
          </FormGroup>
          <FormGroup>
            <Label>Teor</Label>
            <div style={EDITOR_WRAPPER_STYLE}>
              <Editor
                editorState={editCreatedBody}
                onEditorStateChange={es => this.setState({ editCreatedBody: es })}
                toolbar={EDITOR_TOOLBAR}
                toolbarClassName="rdw-toolbar-oficios"
                editorStyle={EDITOR_INNER_STYLE}
                localization={{ locale: 'pt' }}
              />
            </div>
          </FormGroup>
          <FormGroup>
            <Label>Observações</Label>
            <Input type="textarea" rows="2" value={editCreatedObservations}
              onChange={e => this.setState({ editCreatedObservations: e.target.value })} />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={this.closeEditCreatedModal}>Cancelar</Button>
          <Button color="primary" onClick={this.handleEditCreatedSubmit}>Salvar</Button>
        </ModalFooter>
      </Modal>
    )
  }

  renderEditReceivedModal = () => {
    const {
      editReceivedModalIsOpen,
      editingReceivedRow,
      editReceivedNumero,
      editReceivedSender,
      editReceivedDate,
      editReceivedLetterDate,
      editReceivedSubjectBody,
      editReceivedObservations,
      editReceivedTemPrazo,
      editReceivedPrazo,
    } = this.state

    return (
      <Modal size="lg" scrollable centered enforceFocus={false} isOpen={editReceivedModalIsOpen} toggle={this.closeEditReceivedModal}>
        <ModalHeader toggle={this.closeEditReceivedModal}>Editar Ofício Recebido</ModalHeader>
        <ModalBody className="official-letters-modal">
          <FormGroup>
            <Label>Número do ofício do cliente</Label>
            <Input type="text" value={editReceivedNumero} onChange={e => this.setState({ editReceivedNumero: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Remetente</Label>
            <Input type="text" value={editReceivedSender} onChange={e => this.setState({ editReceivedSender: e.target.value })} />
          </FormGroup>
          <FormGroup>
            <Label>Contrato vinculado</Label>
            <Input
              type="text"
              disabled
              value={editingReceivedRow?.contrato_id ? this.getContractName(editingReceivedRow.contrato_id) : '—'}
            />
          </FormGroup>
          <FormGroup>
            <Label>Data de recebimento</Label>
            <ModalDatePicker locale="pt-BR" className="form-control" selected={editReceivedDate} dateFormat="dd/MM/yyyy"
              onChange={date => this.setState({ editReceivedDate: date })} />
          </FormGroup>
          <FormGroup>
            <Label>Data do ofício</Label>
            <ModalDatePicker locale="pt-BR" className="form-control" selected={editReceivedLetterDate} dateFormat="dd/MM/yyyy"
              onChange={date => this.setState({ editReceivedLetterDate: date })} />
          </FormGroup>
          <FormGroup>
            <Label>Assunto/Teor</Label>
            <div style={EDITOR_WRAPPER_STYLE}>
              <Editor
                editorState={editReceivedSubjectBody}
                onEditorStateChange={es => this.setState({ editReceivedSubjectBody: es })}
                toolbar={EDITOR_TOOLBAR}
                toolbarClassName="rdw-toolbar-oficios"
                editorStyle={EDITOR_INNER_STYLE}
                localization={{ locale: 'pt' }}
              />
            </div>
          </FormGroup>
          <FormGroup>
            <Label>Encaminhado para</Label>
            <Input type="text" disabled value={editingReceivedRow?.setor_responsavel || '—'} />
            <small className="text-muted">Definido na criação; a edição não reenvia e-mail.</small>
          </FormGroup>
          <FormGroup>
            <CustomInput type="checkbox" id="editReceivedTemPrazo" label="Prazo para resposta?"
              checked={editReceivedTemPrazo}
              onChange={e => this.setState({ editReceivedTemPrazo: e.target.checked, editReceivedPrazo: e.target.checked ? editReceivedPrazo : '' })} />
          </FormGroup>
          {editReceivedTemPrazo && (
            <FormGroup>
              <Label>Prazo para resposta</Label>
              <ModalDatePicker locale="pt-BR" className="form-control" selected={editReceivedPrazo} dateFormat="dd/MM/yyyy"
                onChange={date => this.setState({ editReceivedPrazo: date })} />
            </FormGroup>
          )}
          <FormGroup>
            <Label>Observações</Label>
            <Input type="textarea" rows="2" value={editReceivedObservations}
              onChange={e => this.setState({ editReceivedObservations: e.target.value })} />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={this.closeEditReceivedModal}>Cancelar</Button>
          <Button color="primary" onClick={this.handleEditReceivedSubmit}>Salvar</Button>
        </ModalFooter>
      </Modal>
    )
  }

  render() {
    const {
      activeTab,
      createModalIsOpen,
      receiveModalIsOpen,
      respondToReceived,
      createNumero,
      createSignatureResponsible,
      createSignatureResponsibleError,
      createSubject,
      createSubjectError,
      createContract,
      createDate,
      createDateError,
      createSendDate,
      createReceiveDate,
      createRecipient,
      createRecipientError,
      createBody,
      createBodyError,
      createAttachment,
      createObservations,
      createLinkReceived,
      createGerarDemanda,
      createDemandaJuridica,
      createDemandaModalOpen,
      receiveNumero,
      receiveSender,
      receiveSenderError,
      receiveContract,
      receiveDate,
      receiveDateError,
      receiveLetterDate,
      receiveLetterDateError,
      receiveSubjectBody,
      receiveSubjectBodyError,
      receiveForwardDepartments,
      receiveForwardDepartmentsError,
      receiveCcEmail,
      receiveAttachment,
      receiveObservations,
      receiveTemPrazo,
      receivePrazo,
      receiveGerarDemanda,
      receiveDemandaJuridica,
      receiveDemandaModalOpen,
    } = this.state

    const { getContractsData, getContractsIsLoading } = this.props.comercial
    const {
      postOfficialLetterCreatedIsLoading,
      postOfficialLetterReceivedIsLoading,
    } = this.props.management
    const isSubmittingCreated = postOfficialLetterCreatedIsLoading
    const isSubmittingReceived = postOfficialLetterReceivedIsLoading
    const submitOverlayMessage = isSubmittingReceived
      ? 'Salvando ofício recebido...'
      : 'Salvando ofício criado...'
    const createBlockedDemandId = this.getCreateFormBlockedDemandId()
    const contractOptions = (getContractsData || []).map(c => ({
      value: c.contrato_id,
      label: `${c.pj_nomefanta || 'Sem Nome'} — ${c.contrato_num ? `Nº ${c.contrato_num}` : `ID: ${c.contrato_id}`}`,
    }))
    const receivedOptions = this.receivedLetters.map(r => ({
      value: getRowId(r, false),
      label: this.getReceivedLabel(getRowId(r, false)),
    }))

    return (
      <div className="page-content">
        <OfficialLetterSubmitOverlay
          isOpen={isSubmittingCreated || isSubmittingReceived}
          message={submitOverlayMessage}
        />
        <Modal size="lg" scrollable centered enforceFocus={false} isOpen={createModalIsOpen} toggle={this.toggleCreateModal} backdrop={isSubmittingCreated ? 'static' : true}>
          <ModalHeader toggle={isSubmittingCreated ? undefined : this.toggleCreateModal}>
            {respondToReceived ? 'Responder Ofício (criar ofício vinculado)' : 'Criar Novo Ofício'}
          </ModalHeader>
          <ModalBody className="official-letters-modal">
            <FormGroup>
              <Label>Número do ofício</Label>
              <Input
                type="text"
                placeholder="2026/001"
                value={createNumero}
                onChange={e => this.setState({ createNumero: e.target.value })}
              />
            </FormGroup>

            <FormGroup>
              <Label>Responsável da assinatura</Label>
              <Input
                type="text"
                value={createSignatureResponsible}
                onChange={e => this.setState({ createSignatureResponsible: e.target.value, createSignatureResponsibleError: '' })}
              />
              {createSignatureResponsibleError && <span style={{ color: 'red' }}>{createSignatureResponsibleError}</span>}
            </FormGroup>

            <FormGroup>
              <Label>Assunto</Label>
              <Input type="text" value={createSubject} onChange={e => this.setState({ createSubject: e.target.value, createSubjectError: '' })} />
              {createSubjectError && <span style={{ color: 'red' }}>{createSubjectError}</span>}
            </FormGroup>

            <FormGroup>
              <Label>Contrato vinculado <span style={{ color: '#888' }}>(opcional)</span></Label>
              <Select
                {...MODAL_SELECT_PROPS}
                isClearable isSearchable
                placeholder={getContractsIsLoading ? 'Carregando...' : 'Selecione...'}
                isDisabled={getContractsIsLoading}
                value={createContract}
                options={contractOptions}
                onChange={contract => this.setState({ createContract: contract })}
              />
            </FormGroup>

            <Row>
              <Col lg={4} md={12} className="mb-2">
                <FormGroup className="mb-0">
                  <Label>Data do ofício</Label>
                  <ModalDatePicker locale="pt-BR" className="form-control" selected={createDate} dateFormat="dd/MM/yyyy"
                    onChange={date => this.setState({ createDate: date, createDateError: '' })} />
                  {createDateError && <span style={{ color: 'red' }}>{createDateError}</span>}
                </FormGroup>
              </Col>
              <Col lg={4} md={12} className="mb-2">
                <FormGroup className="mb-0">
                  <Label>Data de envio <span style={{ color: '#888' }}>(opcional)</span></Label>
                  <ModalDatePicker locale="pt-BR" className="form-control" selected={createSendDate} dateFormat="dd/MM/yyyy" isClearable
                    onChange={date => this.setState({ createSendDate: date })} />
                </FormGroup>
              </Col>
              <Col lg={4} md={12} className="mb-2">
                <FormGroup className="mb-0">
                  <Label>Data de recebimento <span style={{ color: '#888' }}>(opcional)</span></Label>
                  <ModalDatePicker locale="pt-BR" className="form-control" selected={createReceiveDate} dateFormat="dd/MM/yyyy" isClearable
                    onChange={date => this.setState({ createReceiveDate: date })} />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label>Destinatário</Label>
              <Input type="text" value={createRecipient} onChange={e => this.setState({ createRecipient: e.target.value, createRecipientError: '' })} />
              {createRecipientError && <span style={{ color: 'red' }}>{createRecipientError}</span>}
            </FormGroup>

            {!respondToReceived && (
              <FormGroup>
                <Label>Vincular a ofício recebido <span style={{ color: '#888' }}>(opcional)</span></Label>
                <Select
                  {...MODAL_SELECT_PROPS}
                  isClearable
                  placeholder="Selecione..."
                  value={createLinkReceived}
                  options={receivedOptions}
                  onChange={opt => this.setState({ createLinkReceived: opt })}
                />
              </FormGroup>
            )}

            <FormGroup>
              <Label>Teor</Label>
              <div style={{
                ...EDITOR_WRAPPER_STYLE,
                border: createBodyError ? '1px solid red' : EDITOR_WRAPPER_STYLE.border,
              }}>
                <Editor
                  editorState={createBody}
                  onEditorStateChange={editorState => this.setState({ createBody: editorState, createBodyError: '' })}
                  toolbar={EDITOR_TOOLBAR}
                  toolbarClassName="rdw-toolbar-oficios"
                  editorStyle={EDITOR_INNER_STYLE}
                  localization={{ locale: 'pt' }}
                />
              </div>
              {createBodyError && <span style={{ color: 'red', fontSize: 12 }}>{createBodyError}</span>}
            </FormGroup>

            <FormGroup>
              <CustomInput
                type="checkbox"
                id="createGerarDemanda"
                label="Gerar demanda jurídica?"
                checked={createGerarDemanda}
                disabled={!!createBlockedDemandId}
                onChange={this.handleCreateGerarDemandaChange}
              />
              {createBlockedDemandId && (
                <div style={{ marginTop: 6, fontSize: 12, color: '#856404' }}>
                  Demanda #{createBlockedDemandId} já vinculada ao ofício recebido.
                </div>
              )}
              {createGerarDemanda && createDemandaJuridica && (
                <div style={{ marginTop: 8, fontSize: 13 }}>
                  <span className="text-muted">
                    {createDemandaJuridica.tipo_assunto} · {createDemandaJuridica.prioridade}
                    {' · '}
                    {moment(createDemandaJuridica.prazo_atendimento).format('DD/MM/YYYY')}
                  </span>
                  {' '}
                  <Button color="link" size="sm" className="p-0 align-baseline" onClick={this.openCreateDemandaModal}>
                    Editar
                  </Button>
                </div>
              )}
            </FormGroup>

            <FormGroup>
              <Label>Observações <span style={{ color: '#888' }}>(opcional)</span></Label>
              <Input type="textarea" rows="2" value={createObservations} onChange={e => this.setState({ createObservations: e.target.value })} />
            </FormGroup>

            <FormGroup>
              <Label>Anexar arquivo <span style={{ color: '#888' }}>(opcional)</span></Label>
              <Input type="file" onChange={e => this.setState({ createAttachment: e.target.files[0] || null })} />
              {createAttachment && <span style={{ fontSize: 12, color: '#555' }}>📎 {createAttachment.name}</span>}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={this.toggleCreateModal} disabled={isSubmittingCreated}>Cancelar</Button>
            <Button color="primary" onClick={this.handleCreateSubmit} disabled={isSubmittingCreated}>
              {isSubmittingCreated ? <><Spinner size="sm" className="mr-2" />Enviando...</> : 'Enviar'}
            </Button>
          </ModalFooter>
        </Modal>

        <Modal size="lg" scrollable centered enforceFocus={false} isOpen={receiveModalIsOpen} toggle={this.toggleReceiveModal} backdrop={isSubmittingReceived ? 'static' : true}>
          <ModalHeader toggle={isSubmittingReceived ? undefined : this.toggleReceiveModal}>Receber Ofício</ModalHeader>
          <ModalBody className="official-letters-modal">
            <FormGroup>
              <Label>Número do ofício do cliente</Label>
              <Input type="text" placeholder="Ex.: 12345/2026" value={receiveNumero} onChange={e => this.setState({ receiveNumero: e.target.value })} />
            </FormGroup>

            <FormGroup>
              <Label>Remetente</Label>
              <Input type="text" value={receiveSender} onChange={e => this.setState({ receiveSender: e.target.value, receiveSenderError: '' })} />
              {receiveSenderError && <span style={{ color: 'red' }}>{receiveSenderError}</span>}
            </FormGroup>

            <FormGroup>
              <Label>Contrato vinculado <span style={{ color: '#888' }}>(opcional)</span></Label>
              <Select
                {...MODAL_SELECT_PROPS}
                isClearable isSearchable placeholder="Selecione..." isDisabled={getContractsIsLoading}
                value={receiveContract} options={contractOptions} onChange={c => this.setState({ receiveContract: c })} />
            </FormGroup>

            <FormGroup>
              <Label>Data de recebimento</Label>
              <ModalDatePicker locale="pt-BR" className="form-control" selected={receiveDate} dateFormat="dd/MM/yyyy"
                onChange={date => this.setState({ receiveDate: date, receiveDateError: '' })} />
              {receiveDateError && <span style={{ color: 'red' }}>{receiveDateError}</span>}
            </FormGroup>

            <FormGroup>
              <Label>Data do ofício</Label>
              <ModalDatePicker locale="pt-BR" className="form-control" selected={receiveLetterDate} dateFormat="dd/MM/yyyy"
                onChange={date => this.setState({ receiveLetterDate: date, receiveLetterDateError: '' })} />
              {receiveLetterDateError && <span style={{ color: 'red' }}>{receiveLetterDateError}</span>}
            </FormGroup>

            <FormGroup>
              <Label>Assunto/Teor</Label>
              <div style={{
                ...EDITOR_WRAPPER_STYLE,
                border: receiveSubjectBodyError ? '1px solid red' : EDITOR_WRAPPER_STYLE.border,
              }}>
                <Editor
                  editorState={receiveSubjectBody}
                  onEditorStateChange={es => this.setState({ receiveSubjectBody: es, receiveSubjectBodyError: '' })}
                  toolbar={EDITOR_TOOLBAR}
                  toolbarClassName="rdw-toolbar-oficios"
                  editorStyle={EDITOR_INNER_STYLE}
                  localization={{ locale: 'pt' }}
                />
              </div>
              {receiveSubjectBodyError && <span style={{ color: 'red', fontSize: 12 }}>{receiveSubjectBodyError}</span>}
            </FormGroup>

            <FormGroup className="mb-4">
              <Label>Encaminhar para (gerências)</Label>
              <Select
                {...MODAL_MULTI_SELECT_PROPS}
                isMulti
                placeholder="Selecione uma ou mais gerências..."
                value={receiveForwardDepartments}
                options={GERENCIA_EMAIL_OPTIONS}
                onChange={selected => this.setState({ receiveForwardDepartments: selected || [], receiveForwardDepartmentsError: '' })}
              />
              {receiveForwardDepartmentsError && <span style={{ color: 'red' }}>{receiveForwardDepartmentsError}</span>}
            </FormGroup>

            <FormGroup>
              <CustomInput
                type="checkbox"
                id="receiveTemPrazo"
                label="Prazo para resposta?"
                checked={receiveTemPrazo}
                onChange={e => this.setState({ receiveTemPrazo: e.target.checked, receivePrazo: e.target.checked ? receivePrazo : '' })}
              />
            </FormGroup>

            {receiveTemPrazo && (
              <FormGroup>
                <Label>Prazo para resposta</Label>
                <ModalDatePicker locale="pt-BR" className="form-control" selected={receivePrazo} dateFormat="dd/MM/yyyy"
                  onChange={date => this.setState({ receivePrazo: date })} />
              </FormGroup>
            )}

            <FormGroup>
              <CustomInput
                type="checkbox"
                id="receiveGerarDemanda"
                label="Gerar demanda jurídica?"
                checked={receiveGerarDemanda}
                onChange={this.handleReceiveGerarDemandaChange}
              />
              {receiveGerarDemanda && receiveDemandaJuridica && (
                <div style={{ marginTop: 8, fontSize: 13 }}>
                  <span className="text-muted">
                    {receiveDemandaJuridica.tipo_assunto} · {receiveDemandaJuridica.prioridade}
                    {' · '}
                    {moment(receiveDemandaJuridica.prazo_atendimento).format('DD/MM/YYYY')}
                  </span>
                  {' '}
                  <Button color="link" size="sm" className="p-0 align-baseline" onClick={this.openReceiveDemandaModal}>
                    Editar
                  </Button>
                </div>
              )}
            </FormGroup>

            <FormGroup>
              <Label>Com cópia para <span style={{ color: '#888' }}>(opcional)</span></Label>
              <Input type="text" placeholder="email@ecossis.com.br" value={receiveCcEmail}
                onChange={e => this.setState({ receiveCcEmail: e.target.value })} />
            </FormGroup>

            <FormGroup>
              <Label>Observações <span style={{ color: '#888' }}>(opcional)</span></Label>
              <Input type="textarea" rows="2" value={receiveObservations} onChange={e => this.setState({ receiveObservations: e.target.value })} />
            </FormGroup>

            <FormGroup>
              <Label>Anexar arquivo <span style={{ color: '#888' }}>(opcional)</span></Label>
              <Input type="file" onChange={e => this.setState({ receiveAttachment: e.target.files[0] || null })} />
              {receiveAttachment && <span style={{ fontSize: 12, color: '#555' }}>📎 {receiveAttachment.name}</span>}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={this.toggleReceiveModal} disabled={isSubmittingReceived}>Cancelar</Button>
            <Button color="primary" onClick={this.handleReceiveSubmit} disabled={isSubmittingReceived}>
              {isSubmittingReceived ? <><Spinner size="sm" className="mr-2" />Enviando...</> : 'Enviar'}
            </Button>
          </ModalFooter>
        </Modal>

        {this.renderEditCreatedModal()}
        {this.renderEditReceivedModal()}

        <LegalDemandOptionsModal
          isOpen={createDemandaModalOpen}
          toggle={() => this.closeCreateDemandaModal(true)}
          defaults={this.state.createDemandaDefaults}
          contractLabel={createContract?.label}
          onConfirm={this.handleCreateDemandaConfirm}
        />

        <LegalDemandOptionsModal
          isOpen={receiveDemandaModalOpen}
          toggle={() => this.closeReceiveDemandaModal(true)}
          defaults={this.state.receiveDemandaDefaults}
          contractLabel={receiveContract?.label}
          onConfirm={this.handleReceiveDemandaConfirm}
        />

        <LegalDemandOptionsModal
          isOpen={this.state.tableDemandaModalOpen}
          toggle={this.closeTableDemandaModal}
          defaults={this.state.tableDemandaDefaults}
          contractLabel={
            this.state.tableDemandaRow?.contrato_id
              ? this.getContractName(this.state.tableDemandaRow.contrato_id)
              : ''
          }
          onConfirm={this.handleTableDemandaConfirm}
        />

        <LegalDemandOptionsModal
          isOpen={this.state.tableReceivedDemandaModalOpen}
          toggle={this.closeTableReceivedDemandaModal}
          defaults={this.state.tableReceivedDemandaDefaults}
          contractLabel={
            this.state.tableReceivedDemandaRow?.contrato_id
              ? this.getContractName(this.state.tableReceivedDemandaRow.contrato_id)
              : ''
          }
          onConfirm={this.handleTableReceivedDemandaConfirm}
        />

        <Container fluid>
          <Breadcrumbs title="Criação e Recebimento de Ofícios" breadcrumbItems={[]} />

          <Row className="mb-4 align-items-center">
            <Col>
              <Nav tabs className="nav-tabs-custom">
                <NavItem>
                  <NavLink style={{ cursor: 'pointer' }} className={classnames({ active: activeTab === 'created' })}
                    onClick={() => this.setState({ activeTab: 'created' })}>Ofícios Criados</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink style={{ cursor: 'pointer' }} className={classnames({ active: activeTab === 'received' })}
                    onClick={() => this.setState({ activeTab: 'received' })}>Ofícios Recebidos</NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <Button color="primary" onClick={this.toggleCreateModal}>Criar Ofício</Button>
              <Button color="success" onClick={this.toggleReceiveModal}>Receber Ofício</Button>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <CardBody>
                  {activeTab === 'created' ? this.renderCreatedTable() : this.renderReceivedTable()}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  comercial: state.comercial,
  management: state.management,
  auth: state.auth,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getContracts,
  getOfficialLettersCreated,
  postOfficialLetterCreated,
  getOfficialLettersReceived,
  postOfficialLetterReceived,
  updateOfficialLetter,
  generateLegalDemandForOficio,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(OfficialLetters)
